var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 9H10.875V0.75C10.875 0.33525 10.539 0 10.125 0C9.711 0 9.375 0.33525 9.375 0.75V9H0.75C0.336 9 0 9.33525 0 9.75C0 10.1648 0.336 10.5 0.75 10.5H9.375V19.5C9.375 19.9147 9.711 20.25 10.125 20.25C10.539 20.25 10.875 19.9147 10.875 19.5V10.5H19.5C19.914 10.5 20.25 10.1648 20.25 9.75C20.25 9.33525 19.914 9 19.5 9Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconSmall);
export default __webpack_public_path__ + "static/media/AddIconSmall.eacbcb621234ec34c5093e8eaf41c901.svg";
export { ForwardRef as ReactComponent };